"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Breakpoint_1 = require("../../utils/Breakpoint");
const Dimensions_1 = require("../../utils/Dimensions");
const transformBreakpointToCSSMediaQuery_1 = require("../../utils/transformers/transformBreakpointToCSSMediaQuery");
const transformPixelsToRem_1 = require("../../utils/transformers/transformPixelsToRem");
exports.Container = styled_components_1.default.div `
    position: relative;
    width: 100%;
    max-width: ${(0, transformPixelsToRem_1.transformPixelsToRem)(1168)};
    padding-left: ${Dimensions_1.Dimensions.d16};
    padding-right: ${Dimensions_1.Dimensions.d16};
    margin-left: auto;
    margin-right: auto;

    ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.Breakpoint.md, "only")} {
        max-width: ${(0, transformPixelsToRem_1.transformPixelsToRem)(960)};
    }

    ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.Breakpoint.sm, "only")} {
        max-width: ${(0, transformPixelsToRem_1.transformPixelsToRem)(720)};
    }

    ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.Breakpoint.sm, "down")} {
        max-width: ${(0, transformPixelsToRem_1.transformPixelsToRem)(540)};
    }
`;
//# sourceMappingURL=Container.js.map